module.exports = __webpack_public_path__ + "img/supercharge.16ea0532.png";